import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';

export const module1Keys = (t) => [
    {
        key: 'avgCTR',
        label: t('search.ctr_per_position.module_1.avgCTR'),
        render: (data) => numeral(data * 100).format('0.00'),
        icon: 'search',
    },
    {
        key: 'keywords',
        label: t('search.ctr_per_position.module_1.keywords'),
        icon: 'pagev-view',
        yAxisID: 'y1',
        type: 'bar',
    },
    {
        key: 'clicks',
        label: t('search.ctr_per_position.module_1.clicks'),
        icon: 'pagev-view',
        yAxisID: 'y3',
        type: 'bar',
        hidden: true,
    },
    {
        key: 'impressions',
        label: t('search.ctr_per_position.module_1.impressions'),
        icon: 'pagev-view',
        yAxisID: 'y1',
        type: 'bar',
        hidden: true,
    },
];

export const tableColumns = (t) => [
    {
        label: t('search.ctr_per_position.module_2.position'),
        key: 'position',
        data: 'position',
        Component: Cell,
    },
    {
        label: t('search.ctr_per_position.module_2.keywords'),
        key: 'keywords',
        data: 'keywords',
        Component: Cell,
        renderCell: ({ data }) => numeral(data).format('0.0a'),
    },
    {
        label: t('search.ctr_per_position.module_2.avgCTR'),
        key: 'avgCTR',
        data: 'avgCTR',
        Component: Cell,
        renderCell: ({ item }) => numeral(item.clicks / item.impressions).format('0.00%'),
    },
    {
        label: t('search.ctr_per_position.module_2.clicks'),
        key: 'clicks',
        data: 'clicks',
        Component: Cell,
        renderCell: ({ data }) => numeral(data).format('0.0a'),
    },
    {
        label: t('search.ctr_per_position.module_2.impressions'),
        key: 'impressions',
        data: 'impressions',
        Component: Cell,
        renderCell: ({ data }) => numeral(data).format('0.0a'),
    },
];

export function getPercentForChart(allData, oneData) {
    const sumAllData = allData.reduce((acc, curr) => acc + curr, 0);
    const percent = (100 * oneData) / sumAllData;
    return percent;
}
